<template>
  <service-screen-layout
    v-if="
      saleDefinition.definition.cappedService ||
      saleDefinition.definition.uncappedService
    "
    :parts="parts"
  >
    <template v-slot:account>
      <div class="row">
        <div class="col-md-7">
          <ConnectivityPackage
            :bundle="saleDefinition.definition.uncappedService.connectivityPackage"
          />
        </div>
      </div>
    </template>
    <template v-slot:line v-if="saleDefinition.definition.line">
        <ConnectivityLine
          v-allowed:view="['STAFF', 'CLIENT', 'RESELLER', 'SYSTEM']"
          :line="saleDefinition.definition.line"
          @saveSale="saveSale"
        />
    </template>
    <template v-slot:additionalbilling>
        <AdditionalBillingComponent
          v-allowed:view="['STAFF', 'CLIENT', 'RESELLER', 'SYSTEM']"
          :selectablepackages="saleDefinition.selectableOptions.additionalBillingPackage"
          :billingitems="saleDefinition.definition.additionalBilling"
          :saleDefinition="saleDefinition" 
          :emptyBillingComponent="emptyAdditionalBilling"
          :availableperiods="availablePeriods"
          @reloadSale="getSaleDefinition"
        />
    </template>
  </service-screen-layout>
</template>

<script>
import ServiceScreenLayout from "@/layouts/ServiceScreenLayout";
import ConnectivityPackage from "@/components/ObjParts/SingleConstructed/ConnectivityPackage";
import ConnectivityLine from "@/components/ObjParts/SingleCaptured/ConnectivityLine";
import SaleFunctions from "@/pages/Services/SaleFunctions";
import AdditionalBillingComponent from "@/components/ObjParts/MultipleCaptured/AdditionalBillingComponent";

export default {
  extends: SaleFunctions,
  components: {
    ServiceScreenLayout,
    ConnectivityPackage,
    ConnectivityLine,
    AdditionalBillingComponent
  },
  // watch: {
  //   saleDefinition: {
  //     deep: true,
  //     handler(newSaleDef, oldSaleDef) {
  //       if (oldSaleDef.sale.description != newSaleDef.sale.description) {
  //         this.$parent.$refs.serviceTitle.reloadSale();
  //       }
  //     },
  //   },
  // },
  data: function () {
    return {
      parts: [
        {
          name: "account",
          icon: "fa fa-user-circle",
          displayName: "Account",
          permissions: ["*"],
        },
        {
          name: "line",
          icon: "fa fa-link",
          displayName: "Line",
          permissions: ["*"],
        },
        {
          name: "additionalbilling",
          icon: "fa fa-link",
          displayName: "Additional Billing",
          permissions: ["*"],
        },
      ],
      saleDefinition: {
        product: {
          classificationProvider: "",
        },
        sale: {
          created: null,
          saleNumber: null,
        },
        definition: {
          addons: [],
        },
        selectableOptions: {
          additionalBillingPackage: [],
        },
      },
      saleNumber: null,
      emptyAdditionalBilling: {},
      availablePeriods: [],
    };
  },
  mounted() {
    this.saleNumber = Number(this.$route.params.saleNumber);
    this.getSaleDefinition();
  },
  methods: {
     getSaleDefinition: function() {
      const hostUrl = this.$config.aimsAPI;
      this.$http.get(`${hostUrl}sales/definition/sale/${this.saleNumber}`).then(
        (success) => {
          this.saleDefinition = success.data;
          this.getEmptyAdditionalBilling();
          this.getAvailablePeriods();
        },
        (error) => {
          console.error(error);
          this.showError("Error Fetching Sale Definition", error);
        }
      );
    },
    getEmptyAdditionalBilling: function() {
        this.$http.get(this.$config.aimsAPI + "connectivityaccounts/empty/additionalbillingcomponent/" + this.saleDefinition.sale.saleNumber).then(
            (response) => {
                this.emptyAdditionalBilling = response.data; 
            },
            (error) => {
                console.error(error);
                this.showError("Error fetching empty Additional Package", error);
            }
        );
    },
    getAvailablePeriods: function() {
      let availablePeriods = [];
      const hostUrl = this.$config.aimsAPI;
      this.$http.get(`${hostUrl}connectivityaccounts/availableperiods`).then(
        (response) => {
            this.availablePeriods = availablePeriods.concat(response.data);
          },
          (error) => {
            this.showError("Error fetching periods for Additional Billing", error);
            console.error(error);
          }
        );
    },
    saveSale: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$http
            .put(this.$config.aimsAPI + "sales/definition/" + this.saleDefinition.sale.saleNumber + "/update", this.saleDefinition).then(
              (response) => {
                this.showSuccess("Save Success");
                this.saleDefinition = response.data;
                this.saleDefinition.definition.pppoe.fullUsername =
                  this.saleDefinition.definition.pppoe.username +
                  "@" +
                  this.saleDefinition.definition.pppoe.pppoeRealm.name;
              },
              (error) => {
                console.error(error);
                this.showError("Error Saving Pppoe Account", error);
              }
            );
        }
      });
    },
  },
};
</script>
